<template>
    <div  class="container-fluid py-5 wow fadeInUp img" data-wow-delay="0.1s">
    <div style="margin-top: 130px;" class="container text-center">
      <div class="row justify-content-center mt-12">
        <div class="col-lg-6">
          <i class="bi bi-exclamation-triangle display-1 text-primary"></i>
          <h1 class="display-1 fw-bolder">403</h1>
          <p style="font-size: 20px;" class="mb-4 fw-bolder">Bạn không có quyền truy cập vào trang này</p>
            <router-link class="text-dark py-3 px-5 link" to="/"><button class="learn-more text-secondary fs-6">Quay Lại</button></router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<style src="./403.css" scoped></style>
